import { Modal, Button as MButton } from '@mui/material';
import { Add, Close } from '@mui/icons-material';
import { Dropdown, Tooltip } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import { useRubrices } from "store/rubric/selectors";
import styled from "styled-components";
import COLOR from "utils/constants/color";
import ModalMenu from "..";
import AnimatedCheckMark from "components/AnimatedCheckMark";
import { useCurrentUser } from 'store/users/selectors';
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';

const MENU = [
  { id: "owe_created", value: "OneWay Created" },
  { id: "my_created", value: "My Rubrics" },
];

const RubricsCreated = ({
  rubricData,
  selectedIndex,
  setSelectedIndex,
  dataTab,
  is_placement,
  onPreview,
  onEdit,
  onSelect,
}) => {
  const filterRubrics = rubricData.filter((rubric) => {
    const isCreatedByCorrectRole =
        dataTab === "my_created"
            ? rubric?.created_by === "teacher"
            : rubric?.created_by === "owe_admin";
    
    const isVisible = !rubric.is_hide;
    const isPlacementCondition = is_placement ? rubric.is_placement : !rubric.is_placement;
    
    return isCreatedByCorrectRole && isVisible && isPlacementCondition;
});
  return (
    <>
      {filterRubrics?.length !== 0 && (
        <TitleContainer>
          <TitleText className="">Title</TitleText>
          <TitleActions className="">Actions</TitleActions>
        </TitleContainer>
      )}

      <ViewContainer>
        {filterRubrics?.length === 0 && (
          <div className="bubbleNotesNoData text-blue-10">
            No data available
          </div>
        )}
        {filterRubrics &&
          filterRubrics?.map((data, critesionIndex) => (
            <ListView
              key={data?.id}
              onClick={() => {
                setSelectedIndex(data?.id);
              }}
              className="cursor-pointer"
            >
              <RowContent>
                <div>
                  <AssignmentName>
                    {data?.title?.length>80 ? 
                    <Tooltip title={data?.title} getPopupContainer={trigger => trigger.parentNode}>
                      {data?.title?.slice(0, 80) + "..."}
                    </Tooltip>
                    :data?.title}
                  </AssignmentName>
                  <AssignmentAndPoint>
                    {data?.rubrics_meta?.length} criteria
                  </AssignmentAndPoint>
                </div>
                <RowActions onClick={(e) => e.stopPropagation()}>
                  <RowBtn
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      onPreview?.(data);
                    }}
                  >
                    Preview
                  </RowBtn>
                  <RowBtn
                    type="button"
                    $variant="edit"
                    onClick={(e) => {
                      e.stopPropagation();
                      onEdit?.(data);
                    }}
                  >
                    Edit
                  </RowBtn>
                  <RowSubmitBtn
                    type="button"
                    className="cursor-pointer"
                    onClick={(e) => {
                      e.stopPropagation();
                      onSelect?.(data);
                    }}
                  >
                    Select
                  </RowSubmitBtn>
                </RowActions>
              </RowContent>
            </ListView>
          ))}
      </ViewContainer>
    </>
  );
};

const SelectRubricModal = ({
  setAddedRubric = () => {},
  addedRubric,
  resetConfig,
  editable,
  is_placement
}) => {
  const currentUser = useCurrentUser();
  const owe_admin = currentUser?.role === 'owe_admin'
  const teacher = currentUser?.role === 'teacher'
  const [openSelectModal, setSelectModal] = useState(false);
  const [rubricForm, setRubricForm] = useState({ open: false, form: "" });
  const data = useRubrices();
  const [dataTab, setDataTab] = useState((is_placement || owe_admin || teacher) ? "owe_created" : "my_created");
  const [rubricData, setRubricData] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const showAlert = useAlert();

  useEffect(() => {
    if (is_placement) {
      const dt = (data || []).filter(k => k.is_placement)
      setRubricData(dt);
    } else {
      const dt = (data || []).filter(k => !k.is_placement)
      setRubricData(dt);
    }

  }, [data]);

  const onClickHandler = (rubric) => {
    const rubricToAdd = rubric ?? rubricData?.find((x) => x.id === selectedIndex);
    setAddedRubric(rubricToAdd);
    closeHandler();
  };

  const handlePreview = (data) => {
    setSelectedIndex(data?.id);
    setRubricForm({ open: true, form: "previewRubricModal" });
  };

  const handleEdit = (data) => {
    setSelectedIndex(data?.id);
    setRubricForm({ open: true, form: "createRubricModal", editRubric: data });
  };

  const handleSelect = (data) => {
    onClickHandler(data);
  };

  const closeHandler = () => {
    setSelectModal(false);
    setSelectedIndex(null);
    setDataTab((is_placement || owe_admin || teacher) ? "owe_created" : "my_created");
  };

  function navigationToMenu(id) {
    setDataTab(id);
  }
  const rubricNav = () => ({
    items: [
      {
        key: 'create-rubric',
        label: (
          <PaddedBtn
            onClick={(e) => {
              e.preventDefault();
              setRubricForm({ open: true, form: "createRubricModal" });
            }}
          >
            Create My Rubric
          </PaddedBtn>
        ),
        style: { padding: "0px" },
        className: "contextCenter"
      },
      {
        key: 'reuse-rubric',
        label: (
          <PaddedBtn
            disabled={rubricData?.length === 0 || rubricData?.every(item => item.is_hide === true)}
            onClick={(e) => {
              e.preventDefault();
              setSelectModal(true);
            }}
          >
            OneWay Rubrics
          </PaddedBtn>
        ),
        style: { padding: "0px" },
        className: "contextCenter",
        disabled: rubricData?.length === 0 || rubricData?.every(item => item.is_hide === true)
      }
    ]
  });

  const totalPoints = useMemo(() => {
    return addedRubric?.rubrics_meta?.reduce(
      (sum, criterion) =>
        sum + Math.max(...criterion.points.map((point) => point.pointText)),
      0
    )
  }, [addedRubric]);

  const selectedRubricData = useMemo(() => {
    let filterData;
    // preview for activity asssigned
    if (addedRubric?.id) {
      filterData = rubricData?.find((x) => x.id === addedRubric?.id);
    } 
    // preview for select rubric modal
    else {
      filterData = rubricData?.find((x) => x.id === selectedIndex);
    }

    return filterData;
  }, [addedRubric, selectedIndex,rubricData]);

  return (
    <>
      <ModalMenu
        type={rubricForm?.form}
        open={rubricForm?.open}
        is_placement={is_placement}
        close={(data,getRubricData, is_clone_rubric) => {
            if(data?.id){
              const fitlerId = getRubricData?.find((x) => x.id === data?.id) || {};
              setAddedRubric(fitlerId);
            }
          setRubricForm({ form: "", open: false, editRubric: null })
          if(is_clone_rubric && !is_placement){
            showAlert("Rubric cloned successfully.. Please check your rubrics", "success");
            navigationToMenu("my_created");
          }
        }}
        rubrics_meta={
          selectedRubricData?.id && selectedRubricData?.rubrics_meta
        }
        mainTitle={selectedRubricData?.id && selectedRubricData?.title}
        editRubric={rubricForm?.form === "createRubricModal" ? rubricForm?.editRubric : null}
      />

      {!addedRubric?.id ? (
        <Dropdown
          menu={rubricNav()}
          placement="bottomLeft"
          trigger={["click"]}
          disabled={editable?.editing}
          getPopupContainer={() => document.body}
          overlayStyle={{ zIndex: 1600 }}
        >
          <MButton
            variant="contained"
            color="primary"
            type="button"
            onClick={(e) => e.preventDefault()}
          >
            <Add /> Add Rubric
            {/* <CaretDownOutlined style={{ fontSize: '11px', marginLeft: '6px' }} /> */}
          </MButton>
        </Dropdown>
      ) : null}

      {addedRubric?.title && (
        <RubricButton
          type="button"
          onClick={() =>
            setRubricForm({ open: true, form: "previewRubricModal" })
          }
          className="cursor-pointer"
        >
            <AnimatedCheckMark style={{ marginRight: "5px" }}  />
      
          <div>
            Rubric: 
            {/* {addedRubric?.title}  */}
            {addedRubric?.title?.length>50 ? 
            <Tooltip title={addedRubric?.title}>
              {addedRubric?.title?.slice(0, 50) + "..."}
            </Tooltip>
            :addedRubric?.title}
            • {addedRubric?.rubrics_meta?.length}{" "}
            Criteria • {totalPoints} Points
          </div>
        {!editable?.editing &&
          <Close
            onClick={(event) => {
              event.stopPropagation();
              event.preventDefault();
              resetConfig();
            }}
            className="cursor-pointer"
            style={{ fontSize: "19px", marginLeft: "6px", marginTop: -"1px" }}
          />
        }
        </RubricButton>
      )}
      <Modal
        open={openSelectModal}
        onClose={() => {
          setSelectModal(false);
        }}
        className="modal-for-rubric"
      >
        <ModalContent orientation={window.screen.orientation}>
          <div className="flex items-center w-full justify-between">
            <SelectRubricText className="">Select Rubric</SelectRubricText>
            <Button>
              <Close
                className="cursor-pointer"
                onClick={() => {
                  closeHandler();
                }}
              />
            </Button>
          </div>
         {(!is_placement && !owe_admin) ? <MenuWrapper top={"10px"} style={{ width: "100%" }}>
            {MENU.map((x) => {
              return (
                <MenuBtn
                  style={{
                    borderBottom:
                      dataTab === x?.id
                        ? "5px solid rgb(28,49,115)"
                        :  "5px solid lightGrey",
                    color: dataTab === x?.id ? "rgb(28,49,115)" : "black",
                  }}
                  key={x.id}
                  onClick={() => navigationToMenu(x.id)}
                >
                  {x.value}
                </MenuBtn>
              );
            })}
          </MenuWrapper>:null}

          {dataTab == MENU[0].id && (
            <RubricsCreated
              rubricData={rubricData}
              selectedIndex={selectedIndex}
              setSelectedIndex={setSelectedIndex}
              is_placement={is_placement}
              dataTab={dataTab}
              onPreview={handlePreview}
              onEdit={handleEdit}
              onSelect={handleSelect}
            />
          )}

          {dataTab == MENU[1].id && (
            <RubricsCreated
              rubricData={rubricData}
              selectedIndex={selectedIndex}
              setSelectedIndex={setSelectedIndex}
              is_placement={is_placement}
              dataTab={dataTab}
              onPreview={handlePreview}
              onEdit={handleEdit}
              onSelect={handleSelect}
            />
          )}
          {/* {rubricData?.length !== 0 && (
            <BottomContainer>
              {selectedIndex !== null && (
                <SelectButton
                  type="button"
                  onClick={() => handlePreview(rubricData?.find((x) => x.id === selectedIndex))}
                >
                  Preview
                </SelectButton>
              )}

              <SubmitButton
                type="button"
                className="cursor-pointer"
                disabled={selectedIndex == null}
                onClick={() => onClickHandler()}
              >
                Select
              </SubmitButton>
            </BottomContainer>
          )} */}
        </ModalContent>
      </Modal>
    </>
  );
};

export default SelectRubricModal;

const Container = styled.div`
  border-top: 1px solid ${COLOR.black700};
  margin-top: 24px;
  padding-top: 40px;
  width: 100%;
`;

const ButtonLink = styled.button`
  align-items: center;
  background-color: transparent;
  border: none;
  /* color: ${COLOR.black200}; */
  cursor: pointer;
  display: inline-flex;
  flex-direction: row;
  font-size: 12px;
  outline: none;
  padding: 4px 7px;
  color: white;
  text-transform: uppercase;

  &:hover {
    background-color: ${COLOR.green300};
    color: ${COLOR.white};
  }
  @media (min-width: 992px) and (max-width: 1168px) {
    font-size: 9px;
    padding: 4px 6px;
  }
  @media (max-width: 991px) {
    font-size: 20px;
  }
  @media (min-width: 993px) and (max-width: 1366px) {
    font-size: ${(p) => p.to !== "desktop" && "25px"};
  }
  @media (max-width: 1200px) {
    font-size: ${(p) => p.to === "desktop" && "9px"};
  }
  @media (max-width: 568px) {
    padding: 4px 2px;
    // font-size: 20px;
    &:hover {
      font-size: 14px;
      background-color: ${COLOR.green300};
      color: ${COLOR.white};
    }
  }
  @media (max-width: 320px) {
    padding: 4px 1px;
    font-size: 10px;
  }
`;

const PaddedBtn = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  outline: none;
  padding: 8px;
  text-align: left;
  width: 100%;
`;

const RubricButton = styled.button`
  background-color: #fff;
  border: 1px solid #dadce0;
  color: #3c4043;
  fill: #3c4043;
  padding-inline: 12px;
  padding-top: 10px;
  padding-bottom: 9px;
  min-width: 173px;
  border-radius: 16px;
  display: inline-block;
  font-family: "Google Sans", Roboto, Arial, sans-serif;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.25px;
  text-align: center;
  transition: background 0.2s 0.1s;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const SelectButton = styled.button`
  border: 1px solid #dadce0;
  box-sizing: border-box;
  color: #1a73e8;
  // height: 36px;
  width: 100px;
  height: 42px;
  border-radius: 6px;
  outline: none;
  padding: 10px;
  background: transparent;
  cursor: pointer;
`;

const SubmitButton = styled.button`
    background: #1a73e8;
    color: #fff;
    border: none;
    outline: none;
    border-radius: 6px;
    padding: 10px;
    width: 100px;
    height: 42px;
    &:disabled {
    color: #b0b0b0;
    border-color: #e0e0e0;
    background-color: #f5f5f5;
    cursor: not-allowed;
  }

`;

const BottomContainer = styled.div`
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: row;
  flex-shrink: 0;
  justify-content: flex-end;
  margin: 0 -24px -24px -24px;
  padding: 16px;
  gap: 10px;
`;

const AssignmentAndPoint = styled.div`
  color: rgb(95, 99, 104);
  font-family: Roboto, Arial, sans-serif;
  line-height: 1rem;
  font-size: 0.75rem;
  letter-spacing: 0.025em;
  font-weight: 400;
`;

const AssignmentName = styled.div`
color: rgb(60, 64, 67);
    font-family: Roboto, Arial, sans-serif;
    line-height: 1.5rem;
    font-size: 1rem;
    letter-spacing: .00625em;
    font-weight: 400;
}
`;

const ListView = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px 0 8px 8px;
`;

const ViewContainer = styled.div`
  height: 100%;
  outline: none;
  overflow-y: auto;
`;

const TitleText = styled.div`
  display: flex;
  flex: 1 0 536px;
  flex-direction: column;
  overflow: hidden;
  padding-right: 24px;
`;

const TitleContainer = styled.div`
  color: rgb(95, 99, 104);
  font-family: Roboto, Arial, sans-serif;
  line-height: 1rem;
  font-size: 0.75rem;
  letter-spacing: 0.025em;
  font-weight: 400;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: row;
  padding: 8px 0 8px 8px;

  // margin-top: 20px;
`;

const TitleActions = styled.div`
  flex-shrink: 0;
  margin-left: auto;
  padding-right: 8px;
  min-width: 240px;
  text-align: right;
`;

const RowContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  gap: 12px;
`;

const RowActions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
`;

const RowBtn = styled(SelectButton)`
  width: auto;
  min-width: 60px;
  height: 32px;
  padding: 4px 8px;
  font-size: 12px;
  color: ${(p) => (p.$variant === 'edit' ? '#1b5e20' : '#1a73e8')};
`;

const RowSubmitBtn = styled(SubmitButton)`
  width: auto;
  min-width: 60px;
  height: 32px;
  padding: 4px 8px;
  font-size: 12px;
`;

const Button = styled.button`
  background: none;
  border: none;
  outline: none;
  padding: none;
`;

const SelectRubricText = styled.div`
  color: rgb(32, 33, 36);
  font-family: "Google Sans", Roboto, Arial, sans-serif;
  line-height: 1.75rem;
  font-size: 1.375rem;
  letter-spacing: 0;
  font-weight: 400;
`;

const ModalContent = styled.div`
  background-color: white;
  border-radius: 8px;
  padding-bottom: 24px;

  padding-top: 20px;

  position: relative;
  width: ${(props) => (props.orientation === "landscape" ? "90%" : "100%")};
  height: ${(props) => (props.orientation === "landscape" ? "80%" : "100%")};
  box-sizing: border-box;

  max-width: 720px;
  padding: 1.5rem 1.5rem;
  max-height: 600px;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  @media (max-width: 425px) {
    padding: 5px;
  }
`;

const MenuWrapper = styled.div`
  display: flex;
  flex-direction: row;
  //   justify-content: space-between;
  width: 100%;
  min-height: 50px;
  border-radius: 12px;
  //   border: 2px solid ${COLOR.black100};
  //   background-color: ${COLOR.blueish400};
  margin-top: ${(p) => (p.top ? p.top : "50px")};
  align-items: center;
  justify-content:center;
  position: relative;
  padding: 2px 0px;
  flex-wrap: wrap;
`;

const MenuBtn = styled.button`
  background-color: white;
  border-top: none;
  border-left: none;
  border-right: none;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  outline: none;
  transition: all 300ms ease;
  padding: 2px 16px 10px 16px;
  min-width: 150px;
  margin-right: 2px;
  margin-left: 2px;
  @media (max-width: 992px) {
    margin-top: 10px;
  }
`;
